var _effectorFileName = "/builds/gmini/front-common/src/components/BaseConditions/AutocompleteOption.tsx";
import "core-js/modules/es.function.name.js";
import * as React from 'react';
import styled from 'styled-components';
import { Typography } from '@gmini/ui-kit/lib/Typography';
import { Box } from '@gmini/ui-kit/lib/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Root = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  width: '100%'
});
var Name = styled(Typography)({
  flexGrow: 1,
  fontSize: '14px',
  color: '#353B60',
  fontWeight: 500
});
var GroupName = styled(Typography)({
  fontSize: '13px',
  color: 'rgba(53, 59, 96, 0.4)',
  fontWeight: 'normal'
});
export var AutocompleteOption = /*#__PURE__*/React.memo(function (_ref) {
  var name = _ref.name,
      groupName = _ref.groupName;
  return /*#__PURE__*/_jsxs(Root, {
    children: [/*#__PURE__*/_jsx(Name, {
      noWrap: true,
      children: name
    }), /*#__PURE__*/_jsx(GroupName, {
      noWrap: true,
      variant: "caption",
      color: "textSecondary",
      align: "right",
      children: groupName
    })]
  });
});
AutocompleteOption.displayName = 'Option';